<template>
    <div class="clientFooter">
      <div class="container client_container">
        <div class="pc_img">
          <a href="https://jinfm.net/" target="_blank">
            <img src="@/assets/images/clients/logo_poweredby.svg" alt="一刻鯨選" class="pc_img_icon">
          </a>
        </div>
        <div class="mobile_img">
          <div>
            <a href="https://jinfm.net/" target="_blank">
              <img src="@/assets/images/appicon.png" alt="一刻鯨選" class="app_icon">
            </a>
          </div>
          <div class="appsStore_img">
            <a href="https://itunes.apple.com/tw/app/id1440248584?l=zh&mt=8" target="_blank" ><img src="@/assets/images/appstore.png" class="store_icon" title="從 App Store 下載"></a>
            <a href="https://play.google.com/store/apps/details?id=net.jinfm.app"  target="_blank" ><img src="@/assets/images/googleplay.png" class="store_icon" title="從 Google Play 下載"></a>
          </div>
        </div>
        <div class="footer_title text-grey">
          聯合報系 著作權所有 © udngroup.com. All Rights Reserved.
        </div>
      </div>
      <div
        id="bottomsheet"
        class="bottomsheet cilentsBottomSheet">
        <a
        class="mobileDownloadClientsBtn animated slideInUp" v-bind:href="clientsQRCode" target="_blank"  @click="gaClick ('smart banner','下載 App')">
          下載／開啟 App 享受借聽
          <!-- <p class="sub_text">本頁僅提供試聽，前往 App 享受完整服務</p> -->
        </a>
      </div>
      <div id="pagetop">
        <p class="animated slideInUp" title="top">top</p>
      </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ClientsFooter',
  data () {
    return {
      shareUrl: ''
    }
  },
  computed: {
    ...mapGetters([
      'clientsCID',
      'clientsQRCode'
    ])
  },
  created () {},
  methods: {
    gaClick (action, title) {
      this.$ga.event({
        eventCategory: '行銷',
        eventAction: action,
        eventLabel: title
        // eventValue:
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// @import "../../../../assets/scss/clients.scss";

.clientFooter {
  background-color: rgb(243,248,249);
  padding: 35px 0;
}

.pc_img {
  display: none;
  text-align: center;
  margin-bottom: 16px;
  .pc_img_icon {
    width: 180px;
  }
}

.mobile_img{
  text-align: center;
  margin-bottom: 20px;
  .app_icon {
    width: 70px;
    margin-bottom: 16px;
  }
  .appsStore_img {
    >*:not(:last-child) {
      margin-right: 10px;
    }
  }
  .store_icon {
    width: 101px;
  }
}
.footer_title {
  text-align: center;
  font-size: 12px;
  line-height: 20px;
}

// #pagetop {
//   bottom: 85px;
// }

@media screen and (max-width: 374px){
  .cilentsBottomSheet {
    left: -60px;
  }
}

@media screen and (min-width: 576px){
  .pc_img {
    display: block;
  }
  .mobile_img {
    display: none;
  }
  .footer_title {
    font-size: 14px;
  }
}

@media screen and (max-width: 767px){
  .footer_title {
    margin-bottom: 50px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/clients/components/ClientsFooter.vue